import { usePing } from '@/net/usePing';

/**
 * Small latency badge for a screen corner. Colour bands: green <80ms,
 * yellow <160ms, red beyond — or grey while offline.
 */
export function PingIndicator() {
  const { rtt, online } = usePing();

  let color = 'var(--ink-dim)';
  let label = '—';
  if (online && rtt != null) {
    label = `${rtt}ms`;
    color = rtt < 80 ? 'var(--c-green, #34d399)' : rtt < 160 ? 'var(--c-yellow)' : 'var(--c-red)';
  } else if (!online) {
    label = 'offline';
  }

  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        fontFamily: 'var(--f-mono)',
        fontSize: 10,
        color,
        background: 'rgba(0,0,0,0.35)',
        border: '1px solid var(--hairline)',
        borderRadius: 6,
        padding: '3px 7px',
        pointerEvents: 'none',
        whiteSpace: 'nowrap',
      }}
    >
      <span
        style={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          background: color,
          boxShadow: online && rtt != null ? `0 0 5px ${color}` : 'none',
        }}
      />
      {label}
    </div>
  );
}
